import Modal from 'react-bootstrap/Modal'
import { ConfirmBid } from './ConfirmBid'
import { ModalNotification } from './ModalNotification'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalBody from 'react-bootstrap/ModalBody'

const ModalBidConfirmed = ({
    show,
    isPlacingBidModal = false,
    notification,
    confirmModalClosed,
    bidConfirmed,
    auction,
    modalBidConfirmed,
    openMembershipModal,
    minimumBid,
    premiumPercentage
}) => {
    // While in the modal. If notification is empty the render the confirm form. But,
    // if it's not then only render the notification in the modal body.
    const renderModalNotification = () => {
        if (!notification) {
            return null
        }

        return (
            <ModalNotification notification={notification} closeConfirmModal={confirmModalClosed} openMembershipModal={openMembershipModal} />
        )
    }

    const modal_notification = renderModalNotification()

    if (modal_notification) {
        return (
            <Modal show={show} header="Confirm Bid" onHide={confirmModalClosed}>
                <ModalHeader closeButton>
                    <ModalTitle>
                        Confirm Bid
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    {modal_notification}
                </ModalBody>
            </Modal>
        )
    }

    return (
        <Modal
            show={show}
            onHide={confirmModalClosed}
        >
            <ModalHeader closeButton>
                <ModalTitle>
                    Confirm Bid
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <ConfirmBid
                    auction={auction}
                    minimumBid={minimumBid}
                    bidConfirmed={bidConfirmed}
                    onClickHandler={modalBidConfirmed}
                    isPlacingBidModal={isPlacingBidModal}
                    premiumPercentage={premiumPercentage}
                />
            </ModalBody>
        </Modal>
    )
}

export default ModalBidConfirmed
